'use client';

import type { ReactNode } from 'react';
import { NextIntlClientProvider } from 'next-intl';
import main from '@/messages/zh-TW.json';
import club from '@/messages/club/zh-TW.json';
import federation from '@/messages/federation/zh-TW.json';

// Static imports inside a client module: the bundle ships as a cached JS chunk,
// not as RSC props serialised into every page (see src/i18n/client/index.ts).
const messages = { ...main, ...club, ...federation };

export default function zhTWMessages({ children }: { children: ReactNode }) {
  return (
    <NextIntlClientProvider messages={messages} locale="zh-TW" timeZone="Australia/Sydney">
      {children}
    </NextIntlClientProvider>
  );
}
